module.exports = __webpack_public_path__ + "img/测点_减速开关.65f04887.png";